import React, {ReactElement} from 'react';
import {classes} from './TotalsSection.st.css';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TotalsDataHook} from '../../Totals';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../constants';

export interface TotalsSectionProps {
  children?: (ReactElement | false)[] | ReactElement | false;
  title?: string;
  dataHook?: string;
  shouldShowUpperDivider?: boolean;
}

export const TotalsSection = ({children, title, dataHook, shouldShowUpperDivider = false}: TotalsSectionProps) => {
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  const rootClassName = checkoutUIRevampOrderSummary ? classes.root : classes.rootOld;
  const className = shouldShowUpperDivider ? classes.rootWithBorder : rootClassName;

  return (
    <div data-hook={dataHook ?? /* istanbul ignore next */ TotalsDataHook.TotalsSection} className={className}>
      {title && (
        <Text
          data-hook={TotalsDataHook.TotalsSectionTitle}
          className={
            checkoutUIRevampOrderSummary ? classes.sectionTitle : /* istanbul ignore next */ classes.sectionTitleOld
          }>
          {title}
        </Text>
      )}
      {children}
    </div>
  );
};

TotalsSection.displayName = 'Totals.TotalsSection';
